import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import formatFns from 'date-fns/format';
import afterImprove from 'img/aiTools/AiImproveAfterImprove.png';
import videoUrl from 'img/aiTools/aiImprovePopupPromo.mp4';
import freePromo from 'img/aiTools/freePromo.png';
import paidPromo from 'img/aiTools/paidPromo.png';
import React, { type ReactElement } from 'react';
import { aiPhotoImprovePaymiumLimit } from 'reactApp/appHelpers/featuresHelpers/features/aiPhotoImprove';
import { aiRmvBgrndNoLimit, aiRmvBgrndPaymiumLimit } from 'reactApp/appHelpers/featuresHelpers/features/imageTools';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';
import { renderNewComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import type { IProps } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog';
import { renderCommonWhatsNewDialog } from 'reactApp/components/WhatsNewDialog/WhatsNewDialog.helpers';
import { VK_UI_DARK_THEME } from 'reactApp/constants';
import type { ProcessingType } from 'reactApp/modules/aiTools/aiTools.types';
import { sendDwhModal } from 'reactApp/modules/dwh/dwh.helpers';

import styles from './AiImprovePopups.css';

const name = 'nmz_ai_improve_restrict';
const nameDiscard = 'mnz_ai_improve_discard';
const nameDiscardClose = 'mnz_ai_improve_discard_close';
const nameAfter = 'mnz_ai_improve_after_pp';
const nameAfterRmv = 'mnz_ai_rmv_after_pp';
const nameAtPublish = 'mnz_ai_improve_publish';

const urlAiRmvFree = `${cdnPackagesUrl}/static/cloud/ai/photo-improving/rmvFreePromo.png`;
const urlAiRmvPaimium = `${cdnPackagesUrl}/static/cloud/ai/photo-improving/rmvPaimiumPromo.png`;

export const renderAiLimitPromo = ({
    endLimitTime,
    isPaymium = false,
    onPayClick,
    type,
}: {
    endLimitTime: number;
    isPaymium?: boolean;
    onPayClick(): void;
    type?: ProcessingType;
}) => {
    const primaryClickHandler = () => {
        sendDwhModal({ action: 'click', name });

        if (!isPaymium) {
            onPayClick();
        }
    };

    let title: null | ReactElement = null;
    let content: string | ReactElement = '';
    let imageUrl = isPaymium ? paidPromo : freePromo;

    if (type === 'removeBackground') {
        title = isPaymium ? (
            <>
                Нейросеть удалила фон&nbsp;с&nbsp;{aiRmvBgrndPaymiumLimit}&nbsp;фото&nbsp;из&nbsp;{aiRmvBgrndPaymiumLimit}
            </>
        ) : (
            <>Можно удалять фон&nbsp;с&nbsp;{aiRmvBgrndPaymiumLimit}&nbsp;фото в&nbsp;день с&nbsp;подпиской Mail&nbsp;Space</>
        );

        imageUrl = isPaymium ? urlAiRmvPaimium : urlAiRmvFree;

        content = (
            <div className={styles.text}>
                <Spacing size={12} />
                {isPaymium ? (
                    <>Продолжить можно через&nbsp;24&nbsp;часа&nbsp;— в&nbsp;{formatFns(endLimitTime, 'HH:mm')}</>
                ) : (
                    <>
                        Вы&nbsp;удалили фон&nbsp;с&nbsp;нейросетью бесплатно с&nbsp;одного фото. В&nbsp;следующий раз&nbsp;можно
                        через&nbsp;24&nbsp;часа, в&nbsp;{formatFns(endLimitTime, 'HH:mm')}. А&nbsp;с&nbsp;подпиской&nbsp;— сейчас
                    </>
                )}
                <Spacing size={24} />
            </div>
        );
    } else {
        title = isPaymium ? (
            <>
                Нейросеть улучшила {aiPhotoImprovePaymiumLimit}&nbsp;фото&nbsp;из&nbsp;{aiPhotoImprovePaymiumLimit}
            </>
        ) : (
            <>Улучшайте по {aiPhotoImprovePaymiumLimit}&nbsp;фото в&nbsp;день с&nbsp;подпиской Mail&nbsp;Space</>
        );

        content = (
            <div className={styles.text}>
                <Spacing size={12} />
                {isPaymium ? (
                    <>Продолжить можно через&nbsp;24&nbsp;часа&nbsp;— в&nbsp;{formatFns(endLimitTime, 'HH:mm')}</>
                ) : (
                    <>
                        Вы&nbsp;улучшили одно фото с нейросетью бесплатно. Следующее можно — <br />
                        через&nbsp;24&nbsp;часа, в&nbsp;{formatFns(endLimitTime, 'HH:mm')}. А&nbsp;с&nbsp;подпиской&nbsp;— сейчас
                    </>
                )}
                <Spacing size={24} />
            </div>
        );
    }

    const config: IProps = {
        title: <span>{title}</span>,
        content,
        primaryButtonText: <span>{isPaymium ? 'Понятно' : 'Подключить за 1 ₽'}</span>,
        secondaryButtonText: isPaymium ? undefined : 'Не сейчас',
        imageUrl,
        onClick: primaryClickHandler,
        onDismiss: () => {
            sendDwhModal({ name, action: 'close' });
        },
        onShow: () => {
            sendDwhModal({ name });
        },
        onSecondary: () => {
            sendDwhModal({ name, action: 'click', button_name: 'secondary' });
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        closeAfterClick: true,
        className: classNames(styles.root, VK_UI_DARK_THEME),
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        closeIconWrapperClassName: styles.closeIconWrapper,
        imageClassName: styles.image,
        imageWrapperClassName: styles.imageWrapper,
        footerClassName: styles.footer,
        qaId: 'ai-improve-prm-pp',
    };

    renderCommonWhatsNewDialog(config);
};

export const renderDiscardChanges = ({
    endLimitTime,
    isPaymium = false,
    isDiscardFlow = false,
    availableCount = 0,
    type,
    onDiscardClick,
    onSaveClick,
}: {
    isDiscardFlow?: boolean;
    endLimitTime: number;
    availableCount: number;
    isPaymium?: boolean;
    type?: ProcessingType;
    onDiscardClick(): void;
    onSaveClick?(): void;
}) => {
    let name = isDiscardFlow ? nameDiscard : nameDiscardClose;

    if (type === 'removeBackground') {
        name = isDiscardFlow ? 'nmz_ai_rmvbgrnd_restrict' : 'nmz_ai_rmvbgrnd_discard';
    }

    const primaryClickHandler = () => {
        sendDwhModal({ action: 'click', name });

        if (isDiscardFlow) {
            onDiscardClick();
        } else {
            onSaveClick?.();
        }
    };

    const handleClickSecondary = () => {
        sendDwhModal({ action: 'click', name, button_name: 'secondary' });

        if (!isDiscardFlow) {
            onDiscardClick();
        }
    };

    let primaryButtonText = 'Отменить';
    let secondaryButtonText = 'Не отменять';
    let title = 'Отменить изменения?';
    let contentText;

    if (type === 'improve') {
        if (!isDiscardFlow) {
            primaryButtonText = 'Сохранить';
            secondaryButtonText = 'Не сохранять';
            title = 'Сохранить изменения?';
            contentText = isPaymium ? (
                <>
                    Если закрыть, улучшенное нейросетью фото
                    <br />
                    не сохранится. Останется ещё {availableCount} улучшений из {aiPhotoImprovePaymiumLimit} на сутки, до{' '}
                    {formatFns(endLimitTime, 'HH:mm')}
                </>
            ) : (
                <>
                    Если закрыть, улучшенное нейросетью фото
                    <br />
                    не сохранится. Следующее можно будет улучшить через 24 часа
                </>
            );
        } else {
            contentText = isPaymium ? (
                <>
                    Улучшенное нейросетью фото
                    <br />
                    не сохранится — у вас останется
                    <br />
                    ещё {availableCount} улучшений из {aiPhotoImprovePaymiumLimit} на сутки, до {formatFns(endLimitTime, 'HH:mm')}
                </>
            ) : (
                <>
                    Улучшенное нейросетью фото
                    <br />
                    не сохранится — в следующий раз можно улучшить через 24 часа
                </>
            );
        }
    } else {
        title = 'Вернуть фон?';
        contentText = 'Фото без фона не сохранится';
        primaryButtonText = 'Вернуть';
        secondaryButtonText = 'Не возвращать';

        if (!isDiscardFlow) {
            title = 'Сохранить изменения?';
            primaryButtonText = 'Сохранить';
            secondaryButtonText = 'Не сохранять';

            contentText =
                isPaymium && availableCount > 0 ? (
                    <>
                        Если закрыть, фото без фона не сохранится.
                        <br />
                        {!aiRmvBgrndNoLimit && (
                            <>
                                Можно будет удалить фон ещё с {availableCount} фото из {aiRmvBgrndPaymiumLimit}
                                <br />
                                за сутки, до {formatFns(endLimitTime, 'HH:mm')}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        Если закрыть, фото без фона не сохранится.
                        {!aiRmvBgrndNoLimit && (
                            <>
                                <br /> В следующий раз можно будет удалить
                                <br />
                                фон через 24 часа, в&nbsp;{formatFns(endLimitTime, 'HH:mm')}
                            </>
                        )}
                    </>
                );
        } else {
            contentText =
                isPaymium && availableCount > 0 ? (
                    <>
                        Фото без фона не сохранится
                        {!aiRmvBgrndNoLimit && (
                            <>
                                {' '}
                                — можно будет
                                <br />
                                удалить фон ещё с {availableCount} фото из {aiRmvBgrndPaymiumLimit} за сутки,
                                <br />
                                до {formatFns(endLimitTime, 'HH:mm')}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        Фото без фона не сохранится
                        {!aiRmvBgrndNoLimit && (
                            <>
                                {' '}
                                — в следующий
                                <br /> раз можно удалить фон через 24 часа, в&nbsp;{formatFns(endLimitTime, 'HH:mm')}
                            </>
                        )}
                    </>
                );
        }
    }

    renderNewComfirmationDialog({
        renderHeader: () => title,
        renderContent: () => contentText,
        buttons: [EButtonType.accept, EButtonType.cancel],
        successButtonText: primaryButtonText,
        cancelButtonText: secondaryButtonText,
        closeOnDimmerClick: true,
        onClose: () => sendDwhModal({ action: 'close', name }),
        onShow: () => sendDwhModal({ name }),
        onCancel: handleClickSecondary,
        onSuccess: primaryClickHandler,
        size: 'tiny',
        dataQAId: `ai-improve-discard`,
        className: classNames(styles.confirmationRoot, VK_UI_DARK_THEME),
    });
};

export const renderAfterImprovePromo = ({
    endLimitTime,
    onPayClick,
    onShow,
}: {
    endLimitTime: number;
    onPayClick(): void;
    onShow(): void;
}) => {
    const primaryClickHandler = () => {
        sendDwhModal({ action: 'click', name: nameAfter });

        onPayClick();
    };

    const config: IProps = {
        title: <span>Фото улучшено. Если&nbsp;всё нравится,&nbsp;можно продолжить</span>,
        content: (
            <div className={styles.text}>
                <Spacing size={12} />
                Без подписки можно улучшить следующее фото&nbsp;с&nbsp;нейросетью через 24 часа, в&nbsp;{formatFns(endLimitTime, 'HH:mm')}.
                А&nbsp;с&nbsp;подпиской&nbsp;— уже сейчас
                <Spacing size={24} />
            </div>
        ),
        primaryButtonText: <span>Продолжить за 1 ₽</span>,
        imageUrl: afterImprove,
        onClick: primaryClickHandler,
        onDismiss: () => {
            sendDwhModal({ name: nameAfter, action: 'close' });
        },
        onShow: () => {
            sendDwhModal({ name: nameAfter });
            onShow();
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        closeAfterClick: true,
        className: classNames(styles.root, VK_UI_DARK_THEME),
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        imageClassName: styles.image,
        imageWrapperClassName: styles.imageWrapper,
        footerClassName: styles.footer,
        qaId: 'ai-improve-after-pp',
    };

    renderCommonWhatsNewDialog(config);
};

export const renderAfterRmvPromo = ({ endLimitTime, onPayClick, onShow }: { endLimitTime: number; onPayClick(): void; onShow(): void }) => {
    const primaryClickHandler = () => {
        sendDwhModal({ action: 'click', name: nameAfterRmv });

        onPayClick();
    };

    const config: IProps = {
        title: <span>Фон удалён. Если&nbsp;всё нравится, можно продолжить</span>,
        content: (
            <div className={styles.text}>
                <Spacing size={12} />
                Без&nbsp;подписки в&nbsp;следующий раз&nbsp;можно удалить фон&nbsp;с&nbsp;нейросетью через&nbsp;24&nbsp;часа, в&nbsp;
                {formatFns(endLimitTime, 'HH:mm')}. А&nbsp;с&nbsp;подпиской&nbsp;— уже&nbsp;сейчас
                <Spacing size={24} />
            </div>
        ),
        primaryButtonText: <span>Продолжить за 1 ₽</span>,
        imageUrl: `${cdnPackagesUrl}/static/cloud/ai/photo-improving/rmvDonePromo.png`,
        onClick: primaryClickHandler,
        onDismiss: () => {
            sendDwhModal({ name: nameAfterRmv, action: 'close' });
        },
        onShow: () => {
            sendDwhModal({ name: nameAfterRmv });
            onShow();
        },
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        closeAfterClick: true,
        className: classNames(styles.root, VK_UI_DARK_THEME),
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        imageClassName: styles.image,
        imageWrapperClassName: styles.imageWrapper,
        footerClassName: styles.footer,
        qaId: 'ai-rmv-after-pp',
    };

    renderCommonWhatsNewDialog(config);
};

export const renderAiImproveViewerAtPublishPromo = ({
    improveClick,
    secondaryClick,
    onShow,
}: {
    improveClick(): void;
    secondaryClick(): void;
    onShow(): void;
}) => {
    const handlePrimaryClickHandler = () => {
        sendDwhModal({ action: 'click', name: nameAtPublish });

        improveClick();
    };

    const config: IProps = {
        title: <span>Можно повысить качество с&nbsp;нейросетью&nbsp;— и&nbsp;поделиться</span>,
        content: (
            <div className={styles.text}>
                <Spacing size={16} />
                Уберёт шум, добавит контрастности и&nbsp;поможет&nbsp;передать момент
                <Spacing size={32} />
            </div>
        ),
        primaryButtonText: <span>Попробовать</span>,
        secondaryButtonText: 'Не сейчас',
        onClick: handlePrimaryClickHandler,
        onDismiss: () => {
            sendDwhModal({ name: nameAtPublish, action: 'close' });

            secondaryClick();
        },
        onSecondary: () => {
            sendDwhModal({ name: nameAtPublish, action: 'click', button_name: 'secondary' });

            secondaryClick();
        },
        onShow: () => {
            sendDwhModal({ name: nameAtPublish });
            onShow();
        },
        imageUrl: '',
        imageOnlyAdditionalContent: true,
        imageAdditionalContent: <video src={videoUrl} autoPlay muted loop className={styles.video} />,
        dialogSize: 'tiny',
        buttonTheme: 'vk',
        closeAfterClick: true,
        className: classNames(styles.root, VK_UI_DARK_THEME),
        contentClassName: styles.content,
        closeIconClassName: styles.closeIcon,
        imageClassName: styles.image,
        imageWrapperClassName: styles.imageWrapper,
        footerClassName: styles.footer,
        qaId: 'ai-improve-prm-vwr-publish',
    };

    renderCommonWhatsNewDialog(config);
};
